import React, { useEffect } from 'react';
import Lottie from 'react-lottie-player';
import { withMedia } from 'react-media-query-hoc';
import { Button, Modal } from '@domain-group/fe-co-allhomes-design-system';
import CreatePropertyAlert from '@domain-group/fe-co-allhomes-property-alert-common';
import Done from '../../../static/done.json';
import * as styles from './action-popup.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var BaseActionPopup = _ref => {
  var _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? () => {} : _ref$onClose,
    _ref$editPropertyAler = _ref.editPropertyAlert,
    editPropertyAlert = _ref$editPropertyAler === void 0 ? () => {} : _ref$editPropertyAler,
    _ref$managePropertyAl = _ref.managePropertyAlerts,
    managePropertyAlerts = _ref$managePropertyAl === void 0 ? () => {} : _ref$managePropertyAl,
    _ref$createPropertyAl = _ref.createPropertyAlert,
    createPropertyAlert = _ref$createPropertyAl === void 0 ? () => {} : _ref$createPropertyAl,
    _ref$removePropertyAl = _ref.removePropertyAlert,
    removePropertyAlert = _ref$removePropertyAl === void 0 ? () => {} : _ref$removePropertyAl,
    _ref$alertId = _ref.alertId,
    alertId = _ref$alertId === void 0 ? null : _ref$alertId,
    _ref$alertName = _ref.alertName,
    alertName = _ref$alertName === void 0 ? '' : _ref$alertName,
    _ref$filterSummary = _ref.filterSummary,
    filterSummary = _ref$filterSummary === void 0 ? '' : _ref$filterSummary,
    _ref$showCreateConfir = _ref.showCreateConfirmation,
    showCreateConfirmation = _ref$showCreateConfir === void 0 ? false : _ref$showCreateConfir,
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? {} : _ref$media,
    _ref$searchQuery = _ref.searchQuery,
    searchQuery = _ref$searchQuery === void 0 ? null : _ref$searchQuery,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? 'How often would you like us to send them?' : _ref$message,
    _ref$createButtonLabe = _ref.createButtonLabel,
    createButtonLabel = _ref$createButtonLabe === void 0 ? 'Create alert' : _ref$createButtonLabe;
  var containerRef = React.useRef(null);
  useEffect(() => {
    var closePopup = evt => {
      if (containerRef.current && !containerRef.current.contains(evt.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', closePopup, false);
    return () => {
      document.removeEventListener('mousedown', closePopup, false);
    };
  }, [onClose]);
  var displayNoLocation = () => ___EmotionJSX("div", {
    css: styles.confirmContent
  }, ___EmotionJSX("div", {
    css: styles.noLocationMessage
  }, "Please first enter a location to create the property alert."));
  var displayUpdateMenu = () => ___EmotionJSX("div", {
    css: styles.menuContent
  }, ___EmotionJSX("div", {
    css: styles.menuTitle
  }, alertName), ___EmotionJSX("div", {
    css: styles.menuSubTitle
  }, filterSummary), ___EmotionJSX("div", {
    css: styles.divider
  }), ___EmotionJSX("div", {
    css: styles.menuButtonWrapper
  }, ___EmotionJSX(Button, {
    css: styles.menuButton,
    appearance: "ghost",
    onClick: editPropertyAlert
  }, "Edit this alert"), ___EmotionJSX(Button, {
    css: styles.menuButton,
    appearance: "ghost",
    onClick: managePropertyAlerts
  }, "Manage my alerts"), ___EmotionJSX(Button, {
    css: styles.menuButton,
    appearance: "ghost",
    onClick: removePropertyAlert
  }, "Remove this alert"), ___EmotionJSX(Button, {
    css: styles.menuButton,
    appearance: "ghost",
    onClick: onClose
  }, "Cancel")));
  var displayCreateMenu = () => ___EmotionJSX(CreatePropertyAlert, {
    selectedOption: "Instantly",
    onCancel: onClose,
    onCreateAlert: _ref2 => {
      var selectedOption = _ref2.selectedOption;
      return createPropertyAlert(selectedOption);
    },
    message: message,
    createButtonLabel: createButtonLabel,
    css: styles.popupStyle
  });
  var displayConfirm = () => ___EmotionJSX("div", {
    css: styles.confirmContent
  }, ___EmotionJSX("span", {
    css: styles.tickIconWrapper
  }, ___EmotionJSX(Lottie, {
    loop: false,
    animationData: Done,
    play: true,
    style: {
      width: 36,
      height: 36
    }
  })), ___EmotionJSX("span", {
    css: styles.confirmHeading
  }, "Done"), ___EmotionJSX("div", {
    css: styles.confirmMessage
  }, "We'll let you know when new properties are listed that match your search."));
  var displayContent = () => {
    if (!searchQuery) {
      return displayNoLocation();
    }
    if (showCreateConfirmation) {
      return displayConfirm();
    }
    if (alertId) {
      return displayUpdateMenu();
    }
    return displayCreateMenu();
  };
  var mobile = media.mobile;
  return mobile ? ___EmotionJSX(Modal, {
    show: true,
    mobileStyle: "auto",
    showHeader: false,
    onClose: onClose
  }, displayContent()) : ___EmotionJSX("div", {
    css: styles.actionPopup,
    ref: containerRef
  }, displayContent());
};
export var ActionPopup = withMedia(BaseActionPopup);